export const DELIVERY_STATUSES = [
    'Создаём заказ',
    'Заказ создан',
    'Доставляется',
    'Доставлен',
    'Отменён',
    'Возврат',
]

export const DELIVERY_STATUSES_OPTIONS = [
    {
        id: 1,
        name: 'Заказ создан',
    },
    {
        id: 2,
        name: 'Доставляется',
    },
    {
        id: 3,
        name: 'Доставлен',
    },
    {
        id: 4,
        name: 'Отменён',
    },
    {
        id: 5,
        name: 'Возврат',
    },
]

export const TRANSPORT_TYPES_OPTIONS = [
    {
        id: 1,
        name: 'Смешанный',
        value: 'FOOT',
    },
    {
        id: 2,
        name: 'Авто',
        value: 'CAR',
    },
]

export const ORIGIN_OPTIONS = [
    {
        id: 1,
        name: 'Клиент',
    },
    {
        id: 2,
        name: 'Диспетч',
    },
]
